<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormUsuarioAgente" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="header">
                            <th :class="StyleTh+' text-center'">Asignar</th>
                            <th :class="StyleTh">Nombre del Usuario</th>
                            <th :class="StyleTh">Email</th>
                            <th :class="StyleTh">Perfil</th>
                        </template>
                        <template slot="body">
                            <tr v-for="(item, index) in Usuarios" :key="index">
                                <td class="text-center">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" v-model="objUsuarioxAgente.Usuarios" :value="item.IdUsuario" id="flexCheckDefault">
                                        <label class="form-check-label" for="flexCheckDefault">
                                        </label>
                                    </div>
                                </td>
                                <td><h6 :class="StylePr">{{ item.NombreCompleto }}</h6></td>
                                <td><p :class="StyleTd">{{ item.Correo }}</p></td>
                                <td><p :class="StyleTd">{{ item.perfil.Nombre }}</p></td>
                            </tr>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormUsuarioAgente',
    props: ['poBtnSave','Asignados','IdAgente'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigList:{
                BtnNewShow: false,
                ShowTitleFirst: false,
                ShowTitleEnd: false,
                ShowLoader: false,
                ShowEntradas: false,
                ShowPaginador: false, 
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Placeholder: 'Buscar..',
            },
            objUsuarioxAgente: {
				IdAgente: this.IdAgente,
				Usuarios:[]
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Usuarios:[],
            CopiaUsuarios:[],
            ContadorRecuperado:0
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion = [];
			this.poBtnSave.Toast = 0; 
			this.poBtnSave.DisableBtn = true;
            await this.$http.post('usuariosxagente',this.objUsuarioxAgente
            ).then((res) => {
                this.EjecutaConExito(res);
            }).catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.ContadorRecuperado++;
            this.CopiaUsuarios=this.objUsuarioxAgente.Usuarios;
            this.ConfigLoad.ShowLoader = true;
            this.$http.get('usersxEmpresa',{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Estatus: 'Activo',
                    TipoUsuario: 'UH'
                }
            }).then((res) => {
                this.Usuarios = res.data.data;
                this.objUsuarioxAgente.Usuarios = this.Asignados.map((element)=>element.IdUsuario);
                // if (this.CopiaUsuarios.length==0) {
                //     this.CopiaUsuarios=this.objUsuarioxAgente.Usuarios;
                // }
                // else{
                //     this.objUsuarioxAgente=this.CopiaUsuarios;
                // }
                if (this.ContadorRecuperado>1) {
                    this.objUsuarioxAgente.Usuarios=this.CopiaUsuarios;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar(){
            this.ContadorRecuperado=0;
            this.CopiaUsuarios=[];
        },
        // AgregarQuitar(event,item){
        //     if (event.value==true) {
        //         this.CopiaUsuarios.push(item);
        //     }
        //     else{
        //         this.CopiaUsuarios.splice(this.CopiaUsuarios.indexOf(item),1);
        //     }
        // }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            this.Recuperar();
			// let ObjAgente = JSON.parse(sessionStorage.getItem('objAgente'));
			// this.objPaquetehotel.IdAgente = ObjAgente.IdAgente;
                
            // if (Id!='') 
            // {
            //     this.objPaquetehotel.IdPaquete = Id;
            //     this.Recuperar();
            // }
            // else
            // {
            //     this.ConfigLoad.ShowLoader = false;
            // }
        });
    }

}
</script>